var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#4661AF",
    fillRule: "nonzero",
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15 11h2.5l-.313 2.5H15V21h-3.242v-7.5H10V11h1.758V9.32c0-1.093.273-1.92.82-2.48.547-.56 1.458-.84 2.735-.84H17.5v2.5h-1.328c-.495 0-.814.078-.957.234-.143.157-.215.417-.215.782V11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a21796d04aedbcefdb8787cbadd493b1.svg";
export { ForwardRef as ReactComponent };